
import { defineComponent } from "vue";
import FormInput from "./FormInput.vue";

export default defineComponent({
  name: "AddressFields",
  components: { FormInput },
  props: {
    postalCode: { type: String, required: true },
    city: { type: String, required: true }
  },
  emits: ["update:postal-code", "update:city"]
});
